//导出两个店铺list，一个是 mmdShopNameList，一个是 tdzShopNameList
export const mmdShopNameList = [
  {
    id: 1,
    name: "liangjiaoxj",
    user_name: "liangjiaoxj",
    access_token: "6202810270ec0c8c57ZZef47d1d3314546d9f2ef35febc321451241",
    expiration_time: "2022-01-28 00:00:00",
    state: 0,
    state_check: 0,
    auth_response:
      '{"w1_expires_in":0,"refresh_token_valid_time":1643320800000,"taobao_user_nick":"liangjiaoxj","re_expires_in":223538,"expire_time":1643320800000,"token_type":"Bearer","access_token":"6202810270ec0c8c57ZZef47d1d3314546d9f2ef35febc321451241","taobao_open_uid":"AAEdSVkUABuBewa7c6KOpaov","w1_valid":1626766849229,"refresh_token":"6201010f97a3f9bd6egi3f35d148414c31dbdec18724bcd21451241","w2_expires_in":0,"w2_valid":1626765049229,"r1_expires_in":0,"r2_expires_in":0,"r2_valid":1626765049229,"r1_valid":1626766849229,"taobao_user_id":"21451241","expires_in":223538}',
    text: "",
    create_date: "2021-07-08 16:43:26",
    update_date: "2025-01-09 15:14:02",
  },
  {
    id: 2,
    name: "tpmorefun",
    user_name: "tpmorefun",
    access_token: "620232620f0fc9242f0b5325d46f881826ZZf67dc4cf95b1928865133",
    expiration_time: "2026-08-27 06:00:00",
    state: 1,
    state_check: 1,
    auth_response:
      '{"w1_expires_in":1800,"refresh_token_valid_time":1787781600000,"taobao_user_nick":"tpmorefun","re_expires_in":31515695,"expire_time":1787781600000,"token_type":"Bearer","access_token":"620232620f0fc9242f0b5325d46f881826ZZf67dc4cf95b1928865133","taobao_open_uid":"AAGxSVkUABuBewa7c6L9Gt6r","w1_valid":1756267704282,"refresh_token":"620292668891d6d4c879321ba539a9a7aace49bc58bfcd21928865133","w2_expires_in":0,"w2_valid":1756265904282,"r1_expires_in":1800,"r2_expires_in":0,"r2_valid":1756265904282,"r1_valid":1756267704282,"taobao_user_id":"1928865133","expires_in":31515695}',
    text: "",
    create_date: "2021-07-15 17:07:58",
    update_date: "2025-08-27 11:38:24",
  },
  {
    id: 3,
    name: "farfetch%E5%8F%91%E5%8F%91%E5%A5%87%E5%AE%98%E6%96%B9%E6%B5%B7%E5%A4%96%E6%97%97",
    user_name: "farfetch发发奇官方海外旗",
    access_token:
      "62011198e2563c38b332de0af05ZZ6215881e6a48b6f56e2214025301925",
    expiration_time: "2022-07-26 06:00:00",
    state: 0,
    state_check: 0,
    auth_response:
      '{"w1_expires_in":1800,"refresh_token_valid_time":1658786400000,"taobao_user_nick":"farfetch%E5%8F%91%E5%8F%91%E5%A5%87%E5%AE%98%E6%96%B9%E6%B5%B7%E5%A4%96%E6%97%97","re_expires_in":929667,"expire_time":1658786400000,"token_type":"Bearer","sub_taobao_user_id":"2214025301925","access_token":"62011198e2563c38b332de0af05ZZ6215881e6a48b6f56e2214025301925","taobao_open_uid":"AAFwSVkUABuBewS7c6D0md93","w1_valid":1657858532773,"refresh_token":"6201c190116e6911a1732193228ZZ4fb93d7096916ef6bd2214025301925","w2_expires_in":0,"sub_taobao_user_nick":"farfetch%E5%8F%91%E5%8F%91%E5%A5%87%E5%AE%98%E6%96%B9%E6%B5%B7%E5%A4%96%E6%97%97%3A%E7%8E%8B%E5%AE%81","w2_valid":1657856732773,"r1_expires_in":1800,"r2_expires_in":0,"r2_valid":1657856732773,"r1_valid":1657858532773,"taobao_open_sub_uid":"AAEpSVkUABuBewS7c6Hx0_Rj","taobao_user_id":"2209684858033","expires_in":929667}',
    text: "",
    create_date: "2021-07-26 10:30:10",
    update_date: "2022-07-23 10:25:00",
  },
  {
    id: 5,
    name: "cos%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97",
    user_name: "cos官方旗舰店",
    access_token:
      "6201b10576cb0314e2ZZ11861ede9ca4256d439155c58cb2206979849276",
    expiration_time: "2022-08-08 06:00:00",
    state: 0,
    state_check: 0,
    auth_response:
      '{"w1_expires_in":1800,"refresh_token_valid_time":1659909600000,"taobao_user_nick":"cos%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97","re_expires_in":19568690,"expire_time":1659909600000,"token_type":"Bearer","sub_taobao_user_id":"2206979849276","access_token":"6201b10576cb0314e2ZZ11861ede9ca4256d439155c58cb2206979849276","taobao_open_uid":"AAHQSVkUABuBewa7c6J7m5iR","w1_valid":1640342709157,"refresh_token":"62014103c51aad4206ZZ50e932e7a94e236d758f08e38e22206979849276","w2_expires_in":0,"sub_taobao_user_nick":"cos%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97%3Anora","w2_valid":1640340909157,"r1_expires_in":1800,"r2_expires_in":0,"r2_valid":1640340909157,"r1_valid":1640342709157,"taobao_open_sub_uid":"AAFDSVkUABuBewS7c6NV3Qf6","taobao_user_id":"4101595991","expires_in":19568690}',
    text: "",
    create_date: "2021-08-02 11:36:49",
    update_date: "2022-08-05 10:25:00",
  },
  {
    id: 6,
    name: "%E9%80%90%E6%9C%AC%E6%97%97%E8%88%B0%E5%BA%97",
    user_name: "逐本旗舰店",
    access_token:
      "6202221833611fffae43190775b04ZZf06f5b123f1e98582200828292428",
    expiration_time: "2022-08-03 00:00:00",
    state: 0,
    state_check: 0,
    auth_response:
      '{"w1_expires_in":0,"refresh_token_valid_time":1659477600000,"taobao_user_nick":"%E9%80%90%E6%9C%AC%E6%97%97%E8%88%B0%E5%BA%97","re_expires_in":16267747,"expire_time":1659477600000,"token_type":"Bearer","access_token":"6202221833611fffae43190775b04ZZf06f5b123f1e98582200828292428","taobao_open_uid":"AAHHSVkUABuBewS7c6LkdFaK","w1_valid":1627980063267,"refresh_token":"6200e21d731cf0e8a55d46c1d7e21ZZ353a67baf165981d2200828292428","w2_expires_in":0,"w2_valid":1627978263267,"r1_expires_in":0,"r2_expires_in":0,"r2_valid":1627978263267,"r1_valid":1627980063267,"taobao_user_id":"2200828292428","expires_in":16267747}',
    text: "",
    create_date: "2021-08-03 16:11:03",
    update_date: "2022-07-31 10:25:00",
  },
  {
    id: 7,
    name: "%E9%AB%98%E9%9C%B2%E6%B4%81%E6%A3%95%E6%A6%84%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97",
    user_name: "高露洁棕榄官方旗舰店",
    access_token: "62007253c35490cb6de053661e20e1fa8ZZ6c19f10bf8e61818112330",
    expiration_time: "2022-08-06 00:00:00",
    state: 0,
    state_check: 0,
    auth_response:
      '{"w1_expires_in":1800,"refresh_token_valid_time":1659736800000,"taobao_user_nick":"%E9%AB%98%E9%9C%B2%E6%B4%81%E6%A3%95%E6%A6%84%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97","re_expires_in":31518766,"expire_time":1659736800000,"token_type":"Bearer","access_token":"62007253c35490cb6de053661e20e1fa8ZZ6c19f10bf8e61818112330","taobao_open_uid":"AAGGSVkUABuBewa7c6LjvMqM","w1_valid":1628219833120,"refresh_token":"6200d256f3e85f8a7b35f452ec1e11e2fhj232b8c0b307f1818112330","w2_expires_in":0,"w2_valid":1628218033120,"r1_expires_in":1800,"r2_expires_in":0,"r2_valid":1628218033120,"r1_valid":1628219833120,"taobao_user_id":"1818112330","expires_in":31518766}',
    text: "",
    create_date: "2021-08-06 10:47:13",
    update_date: "2022-08-03 10:25:00",
  },
  {
    id: 8,
    name: "nike%E5%84%BF%E7%AB%A5%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97",
    user_name: "nike儿童官方旗舰店",
    access_token: "6200b09efbba57840ZZf6b541a93a4f51f5021a073ac0853728394127",
    expiration_time: "2025-11-30 06:00:00",
    state: 1,
    state_check: 1,
    auth_response:
      '{"w1_expires_in":1800,"refresh_token_valid_time":1732917600000,"taobao_user_nick":"nike%E5%84%BF%E7%AB%A5%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97","re_expires_in":14580550,"expire_time":1732917600000,"token_type":"Bearer","access_token":"6200b09efbba57840ZZf6b541a93a4f51f5021a073ac0853728394127","taobao_open_uid":"AAE_SVkUABuBewa7c6JR2DxJ","w1_valid":1718338849284,"refresh_token":"620090903c67d59abdff402107c27356f34d6242a8651603728394127","w2_expires_in":0,"w2_valid":1718337049284,"r1_expires_in":1800,"r2_expires_in":0,"r2_valid":1718337049284,"r1_valid":1718338849284,"taobao_user_id":"3728394127","expires_in":14580550}',
    text: "",
    create_date: "2021-08-12 10:44:58",
    update_date: "2024-06-14 11:50:49",
  },
  {
    id: 9,
    name: "vans%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97",
    user_name: "vans官方旗舰店",
    access_token: "620251306be2f31cc358aceae0e9e2a844e527fc7ae8639746866993",
    expiration_time: "2024-08-15 00:00:00",
    state: 0,
    state_check: 0,
    auth_response:
      '{"w1_expires_in":0,"refresh_token_valid_time":1723672800000,"taobao_user_nick":"vans%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97","re_expires_in":21751473,"expire_time":1723672800000,"token_type":"Bearer","access_token":"620251306be2f31cc358aceae0e9e2a844e527fc7ae8639746866993","taobao_open_uid":"AAHDSVkUABuBewa7c6KjZrL3","w1_valid":1692019859214,"refresh_token":"62018137951c9e93c3420ZZe4e26873a97ed09405bc2117746866993","w2_expires_in":0,"w2_valid":1692018059214,"r1_expires_in":0,"r2_expires_in":0,"r2_valid":1692018059214,"r1_valid":1692019859214,"taobao_user_id":"746866993","expires_in":21751473}',
    text: "",
    create_date: "2021-08-16 18:10:36",
    update_date: "2023-12-07 11:55:26",
  },
  {
    id: 10,
    name: "lamer%E6%B5%B7%E8%93%9D%E4%B9%8B%E8%B0%9C%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97",
    user_name: "lamer海蓝之谜官方旗舰店",
    access_token: "62003161f1fec46902dae226ZZ24de6b04ed125456ab9742424298091",
    expiration_time: "2024-05-26 00:00:00",
    state: 0,
    state_check: 0,
    auth_response:
      '{"w1_expires_in":1800,"refresh_token_valid_time":1716674400000,"taobao_user_nick":"lamer%E6%B5%B7%E8%93%9D%E4%B9%8B%E8%B0%9C%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97","re_expires_in":31591432,"expire_time":1716674400000,"token_type":"Bearer","access_token":"62003161f1fec46902dae226ZZ24de6b04ed125456ab9742424298091","taobao_open_uid":"AAGbSVkUABuBewa7c6IfnSGt","w1_valid":1685084767856,"refresh_token":"6200116e95dd5e4b4387603cegfb7010b11ce1b53a98d8e2424298091","w2_expires_in":0,"w2_valid":1685082967856,"r1_expires_in":1800,"r2_expires_in":0,"r2_valid":1685082967856,"r1_valid":1685084767856,"taobao_user_id":"2424298091","expires_in":31591432}',
    text: "",
    create_date: "2021-11-12 15:20:23",
    update_date: "2024-05-26 10:25:00",
  },
  {
    id: 11,
    name: "nike%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97",
    user_name: "nike官方旗舰店",
    access_token: "6200527ea73e5fa401bee63db83eeb9e6b3ZZ27b098814e890482188",
    expiration_time: "2025-11-30 06:00:00",
    state: 1,
    state_check: 1,
    auth_response:
      '{"w1_expires_in":1800,"refresh_token_valid_time":1732917600000,"taobao_user_nick":"nike%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97","re_expires_in":14580507,"expire_time":1732917600000,"token_type":"Bearer","access_token":"6200527ea73e5fa401bee63db83eeb9e6b3ZZ27b098814e890482188","taobao_open_uid":"AAHbSVkUABuBewa7c6K68VXK","w1_valid":1718338892142,"refresh_token":"620172750eceed865fe8f13cd87ddbdf8cdfh4c4198393f890482188","w2_expires_in":0,"w2_valid":1718337092142,"r1_expires_in":1800,"r2_expires_in":0,"r2_valid":1718337092142,"r1_valid":1718338892142,"taobao_user_id":"890482188","expires_in":14580507}',
    text: "",
    create_date: "2021-11-29 15:11:13",
    update_date: "2024-06-14 11:51:32",
  },
  {
    id: 12,
    name: "jordan%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97",
    user_name: "jordan官方旗舰店",
    access_token: "6200322e9d190c218f9265fe3a4817ZZcfd9de510920c833327042818",
    expiration_time: "2025-11-30 06:00:00",
    state: 1,
    state_check: 1,
    auth_response:
      '{"w1_expires_in":1800,"refresh_token_valid_time":1732917600000,"taobao_user_nick":"jordan%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97","re_expires_in":14580577,"expire_time":1732917600000,"token_type":"Bearer","access_token":"6200322e9d190c218f9265fe3a4817ZZcfd9de510920c833327042818","taobao_open_uid":"AAEoSVkUABuBewa7c6JJrF7E","w1_valid":1718338822760,"refresh_token":"62025228126f3c839f42dcbd0a9752ZZ51fee45a8d2c5773327042818","w2_expires_in":0,"w2_valid":1718337022760,"r1_expires_in":1800,"r2_expires_in":0,"r2_valid":1718337022760,"r1_valid":1718338822760,"taobao_user_id":"3327042818","expires_in":14580577}',
    text: "",
    create_date: "2021-11-29 15:13:21",
    update_date: "2024-06-14 11:50:22",
  },
  {
    id: 13,
    name: "converse%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97",
    user_name: "converse官方旗舰店",
    access_token: "6201e162f2b8b4d63ad64347ZZdc89cd9ea6b5261669bd11046707508",
    expiration_time: "2025-02-28 06:00:00",
    state: 0,
    state_check: 0,
    auth_response:
      '{"w1_expires_in":1800,"refresh_token_valid_time":1709071200000,"taobao_user_nick":"converse%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97","re_expires_in":152917,"expire_time":1709071200000,"token_type":"Bearer","access_token":"6201e162f2b8b4d63ad64347ZZdc89cd9ea6b5261669bd11046707508","taobao_open_uid":"AAG7SVkUABuBewa7c6KxgYby","w1_valid":1708920082332,"refresh_token":"6201e162f2b8b4d63ad64347ZZab9ff79ea6b5261669bd11046707508","w2_expires_in":0,"w2_valid":1708918282332,"r1_expires_in":1800,"r2_expires_in":0,"r2_valid":1708918282332,"r1_valid":1708920082332,"taobao_user_id":"1046707508","expires_in":152917}',
    text: "",
    create_date: "2022-02-28 11:17:59",
    update_date: "2025-03-04 09:30:13",
  },
  {
    id: 14,
    name: "%E8%8A%AD%E6%AF%94%E6%B3%A2%E6%9C%97%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97",
    user_name: "芭比波朗官方旗舰店",
    access_token: "6202b199d51fed9eba12fa91aeace63da309647ce911f392563613536",
    expiration_time: "2023-04-16 00:00:00",
    state: 0,
    state_check: 0,
    auth_response:
      '{"w1_expires_in":1777,"refresh_token_valid_time":1681596000000,"taobao_user_nick":"%E8%8A%AD%E6%AF%94%E6%B3%A2%E6%9C%97%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97","re_expires_in":29860018,"expire_time":1681596000000,"token_type":"Bearer","access_token":"6202b199d51fed9eba12fa91aeace63da309647ce911f392563613536","taobao_open_uid":"AAHVSVkUABuBewa7c6IXL1im","w1_valid":1651737759100,"refresh_token":"62001193629b97757d301b17b16ZZdef00f8695059da3152563613536","w2_expires_in":0,"w2_valid":1651735959100,"r1_expires_in":1777,"r2_expires_in":0,"r2_valid":1651735959100,"r1_valid":1651737759100,"taobao_user_id":"2563613536","expires_in":29860018}',
    text: "",
    create_date: "2022-05-05 15:32:39",
    update_date: "2023-04-16 10:25:00",
  },
  {
    id: 15,
    name: "pandora%E6%BD%98%E5%A4%9A%E6%8B%89%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97",
    user_name: "pandora潘多拉官方旗舰店",
    access_token: "62000280adfb33fd0147fa3fb88c92c27d98ZZ50bd851132978217349",
    expiration_time: "2024-10-10 00:00:00",
    state: 0,
    state_check: 0,
    auth_response:
      '{"w1_expires_in":1800,"refresh_token_valid_time":1696888800000,"taobao_user_nick":"pandora%E6%BD%98%E5%A4%9A%E6%8B%89%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97","re_expires_in":152690,"expire_time":1696888800000,"token_type":"Bearer","access_token":"62000280adfb33fd0147fa3fb88c92c27d98ZZ50bd851132978217349","taobao_open_uid":"AAF5SVkUABuBewa7c6I-YQZD","w1_valid":1696737909135,"refresh_token":"62006282ac2688200a83e6209dd6a18f5c7bdf289d7a10b2978217349","w2_expires_in":0,"w2_valid":1696736109135,"r1_expires_in":1800,"r2_expires_in":0,"r2_valid":1696736109135,"r1_valid":1696737909135,"taobao_user_id":"2978217349","expires_in":152690}',
    text: "",
    create_date: "2022-10-10 14:02:56",
    update_date: "2023-10-10 10:25:00",
  },
  {
    id: 16,
    name: "%E6%8B%BE%E6%B0%9B%E6%B0%94%E7%9B%92%E6%B5%B7%E5%A4%96%E6%97%97%E8%88%B0%E5%BA%97",
    user_name: "拾氛气盒海外旗舰店",
    access_token:
      "6201c196eb42f1f9539f3f9f348ZZ785b0a112332c7ccde2212904284938",
    expiration_time: "2023-11-21 00:00:00",
    state: 0,
    state_check: 0,
    auth_response:
      '{"w1_expires_in":1800,"refresh_token_valid_time":1700517600000,"taobao_user_nick":"%E6%8B%BE%E6%B0%9B%E6%B0%94%E7%9B%92%E6%B5%B7%E5%A4%96%E6%97%97%E8%88%B0%E5%BA%97","re_expires_in":31499818,"expire_time":1700517600000,"token_type":"Bearer","access_token":"6201c196eb42f1f9539f3f9f348ZZ785b0a112332c7ccde2212904284938","taobao_open_uid":"AAETSVkUABuBewS7c6G0vUjM","w1_valid":1669019581292,"refresh_token":"6201a1942a160b1caf201a9a3dbdf9b035f2eeaf0637cb12212904284938","w2_expires_in":0,"w2_valid":1669017781292,"r1_expires_in":1800,"r2_expires_in":0,"r2_valid":1669017781292,"r1_valid":1669019581292,"taobao_user_id":"2212904284938","expires_in":31499818}',
    text: "",
    create_date: "2022-11-21 16:03:01",
    update_date: "2023-11-21 10:25:00",
  },
  {
    id: 17,
    name: "descente%E8%BF%AA%E6%A1%91%E7%89%B9%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97",
    user_name: "descente迪桑特官方旗舰店",
    access_token: "62007001ZZ78a250a66f33d33200c6a8cbaae0e4454bdcc3299471109",
    expiration_time: "2024-09-04 00:00:00",
    state: 0,
    state_check: 0,
    auth_response:
      '{"w1_expires_in":1800,"refresh_token_valid_time":1725400800000,"taobao_user_nick":"descente%E8%BF%AA%E6%A1%91%E7%89%B9%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97","re_expires_in":31605022,"expire_time":1725400800000,"token_type":"Bearer","access_token":"62007001ZZ78a250a66f33d33200c6a8cbaae0e4454bdcc3299471109","taobao_open_uid":"AAH-SVkUABuBewa7c6JLSxTD","w1_valid":1693797577317,"refresh_token":"6202b007ZZ353603263e36cceb23e614634aff32e752a693299471109","w2_expires_in":0,"w2_valid":1693795777317,"r1_expires_in":1800,"r2_expires_in":0,"r2_valid":1693795777317,"r1_valid":1693797577317,"taobao_user_id":"3299471109","expires_in":31605022}',
    text: "",
    create_date: "2023-09-04 10:49:37",
    update_date: "2023-09-04 10:49:37",
  },
  {
    id: 18,
    name: "jackwolfskin%E7%8B%BC%E7%88%AA%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97",
    user_name: "jackwolfskin狼爪官方旗舰店",
    access_token: "6201319bcd6a5a5ce01f90b6fc1ZZ86f5515265f987d61d585762759",
    expiration_time: "2024-10-16 00:00:00",
    state: 0,
    state_check: 0,
    auth_response:
      '{"w1_expires_in":0,"refresh_token_valid_time":1729029600000,"taobao_user_nick":"jackwolfskin%E7%8B%BC%E7%88%AA%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97","re_expires_in":27268295,"expire_time":1729029600000,"token_type":"Bearer","access_token":"6201319bcd6a5a5ce01f90b6fc1ZZ86f5515265f987d61d585762759","taobao_open_uid":"AAHDSVkUABuBewa7c6KtCPwB","w1_valid":1697442243398,"refresh_token":"6202819ce0b177a945f5ddda47fhj0bd45efe83ad8619ff585762759","w2_expires_in":0,"w2_valid":1697440443398,"r1_expires_in":0,"r2_expires_in":0,"r2_valid":1697440443398,"r1_valid":1697442243398,"taobao_user_id":"585762759","expires_in":27268295}',
    text: "",
    create_date: "2023-10-16 15:14:03",
    update_date: "2023-12-05 15:28:24",
  },
  {
    id: 19,
    name: "nike%E5%AE%98%E6%96%B9outlets%E5%BA%97",
    user_name: "nike官方outlets店",
    access_token:
      "6200f04f1157ZZdb7fe36a9b89dd1535abea12533694e092211883262676",
    expiration_time: "2025-10-18 06:00:00",
    state: 1,
    state_check: 0,
    auth_response:
      '{"w1_expires_in":1800,"refresh_token_valid_time":1729202400000,"taobao_user_nick":"nike%E5%AE%98%E6%96%B9outlets%E5%BA%97","re_expires_in":31585262,"expire_time":1729202400000,"token_type":"Bearer","access_token":"6200f04f1157ZZdb7fe36a9b89dd1535abea12533694e092211883262676","taobao_open_uid":"AAFPSVkUABuBewS7c6BxZtkS","w1_valid":1697618937211,"refresh_token":"6201504e2faceg166a070b8757cb452d1bee9be543448902211883262676","w2_expires_in":0,"w2_valid":1697617137211,"r1_expires_in":1800,"r2_expires_in":0,"r2_valid":1697617137211,"r1_valid":1697618937211,"taobao_user_id":"2211883262676","expires_in":31585262}',
    text: "",
    create_date: "2023-10-18 16:18:57",
    update_date: "2023-10-18 16:18:57",
  },
];

export const tdzShopNameList = [
  {
    id: 5,
    name: "liangjiaoxj",
    user_name: "liangjiaoxj",
    access_token: "620292781c6d1f15b3076937d56bd02e56cega7b63afb7221451241",
    expiration_time: "2023-01-01 00:00:00",
    state: 0,
    state_check: 0,
    auth_response: '{"taobao_user_id":"21451241"}',
    text: null,
    create_date: "2023-06-12 13:55:27",
    update_date: "2023-06-12 13:55:27",
  },
  {
    id: 6,
    name: "millies妙丽旗舰店",
    user_name: "millies妙丽旗舰店",
    access_token: "6101620e69e43ef6bc2712d830df1ffb2caff3435d4574f2940677727",
    expiration_time: "2024-09-08 00:00:00",
    state: 0,
    state_check: 0,
    auth_response: '{"taobao_user_id":"2940677727"}',
    text: null,
    create_date: "2023-06-12 13:55:27",
    update_date: "2023-06-12 13:55:27",
  },
  {
    id: 7,
    name: "mms官方旗舰店",
    user_name: "mms官方旗舰店",
    access_token: "6202327f23a77a1662fa6947d6e0064ddb8ZZ4d3fb4f2211642972723",
    expiration_time: "2021-12-09 00:00:00",
    state: 0,
    state_check: 0,
    auth_response: '{"taobao_user_id":"1642972723"}',
    text: null,
    create_date: "2023-06-12 13:55:27",
    update_date: "2023-06-12 13:55:27",
  },
  {
    id: 8,
    name: "pandora潘多拉官方旗舰店",
    user_name: "pandora潘多拉官方旗舰店",
    access_token: "6200313364322f92c0031ZZf8dc1ca190db44f7558d15052978217349",
    expiration_time: "2022-07-07 00:00:00",
    state: 0,
    state_check: 0,
    auth_response: '{"taobao_user_id":"2978217349"}',
    text: null,
    create_date: "2023-06-12 13:55:27",
    update_date: "2023-06-12 13:55:27",
  },
  {
    id: 9,
    name: "staccato旗舰店",
    user_name: "staccato旗舰店",
    access_token: "6101d00717f4979b4d7421a63ad2d153cf3090a764bdece1731961317",
    expiration_time: "2026-09-06 06:00:00",
    state: 1,
    state_check: 1,
    auth_response: '{"taobao_user_id":"1731961317"}',
    text: null,
    create_date: "2023-06-12 13:55:27",
    update_date: "2025-09-08 09:51:29",
  },
  {
    id: 10,
    name: "乐高官方旗舰店",
    user_name: "乐高官方旗舰店",
    access_token: "6200b135b4d12e5fa4d48ZZ7614b19cdcf511b68f91c904766568254",
    expiration_time: "2023-01-01 00:00:00",
    state: 0,
    state_check: 0,
    auth_response: '{"taobao_user_id":"766568254"}',
    text: null,
    create_date: "2023-06-12 13:55:27",
    update_date: "2023-06-12 13:55:27",
  },
  {
    id: 11,
    name: "佛瑞黎旗舰店",
    user_name: "佛瑞黎旗舰店",
    access_token:
      "6202004211c5ZZ2a78691144e0a08532131b36399e516c42200728656004",
    expiration_time: "2023-01-01 00:00:00",
    state: 0,
    state_check: 0,
    auth_response: '{"taobao_user_id":"2200728656004"}',
    text: null,
    create_date: "2023-06-12 13:55:27",
    update_date: "2023-06-12 13:55:27",
  },
  {
    id: 12,
    name: "天美意官方旗舰店",
    user_name: "天美意官方旗舰店",
    access_token: "6201913579417553d513ace02e0e61976210f6b09090823353042333",
    expiration_time: "2023-01-01 00:00:00",
    state: 0,
    state_check: 0,
    auth_response: '{"taobao_user_id":"353042333"}',
    text: null,
    create_date: "2023-06-12 13:55:27",
    update_date: "2023-06-12 13:55:27",
  },
  {
    id: 13,
    name: "森达官方旗舰店",
    user_name: "森达官方旗舰店",
    access_token: "6100117db018c0eded536b1111e0ce9f4b10f996e693fda708668355",
    expiration_time: "2026-05-04 06:00:00",
    state: 1,
    state_check: 1,
    auth_response: '{"taobao_user_id":"708668355"}',
    text: null,
    create_date: "2023-06-12 13:55:27",
    update_date: "2025-04-30 09:50:55",
  },
  {
    id: 14,
    name: "百思图官方旗舰店",
    user_name: "百思图官方旗舰店",
    access_token: "6102a28a79915d34050cf10c228da7104b8916970354bad829273025",
    expiration_time: "2026-09-06 06:00:00",
    state: 1,
    state_check: 1,
    auth_response: '{"taobao_user_id":"829273025"}',
    text: null,
    create_date: "2023-06-12 13:55:27",
    update_date: "2025-09-08 09:51:47",
  },
  {
    id: 16,
    name: "森达男鞋旗舰店",
    user_name: "森达男鞋旗舰店",
    access_token: null,
    expiration_time: "2026-05-11 00:00:00",
    state: 1,
    state_check: 1,
    auth_response: '{"taobao_user_id":"2214005689190"}',
    text: null,
    create_date: null,
    update_date: "2025-08-20 10:08:31",
  },
  {
    id: 17,
    name: "jordan%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97",
    user_name: "jordan官方旗舰店",
    access_token: "620181576b5253d6bdc30ebdf2814d5b5275fc47072475f3327042818",
    expiration_time: "2026-06-28 06:00:00",
    state: 1,
    state_check: 1,
    auth_response:
      '{"w1_expires_in":834543,"refresh_token_valid_time":1751061600000,"taobao_user_nick":"jordan%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97","re_expires_in":834543,"expire_time":1751061600000,"token_type":"Bearer","access_token":"620181576b5253d6bdc30ebdf2814d5b5275fc47072475f3327042818","taobao_open_uid":"AAECsD1fAATDFH4XlaUX0Ad-","w1_valid":1751061600000,"refresh_token":"6202b159c33568f82bb89ffhjf12edbad99ea97716723bb3327042818","w2_expires_in":1800,"w2_valid":1750228856769,"r1_expires_in":834543,"r2_expires_in":259200,"r2_valid":1750486256769,"r1_valid":1751061600000,"taobao_user_id":"3327042818","expires_in":834543}',
    text: "",
    create_date: "2023-06-28 12:04:36",
    update_date: "2025-06-30 09:48:26",
  },
  {
    id: 18,
    name: "nike%E5%84%BF%E7%AB%A5%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97",
    user_name: "nike儿童官方旗舰店",
    access_token: "62027304860cdd60b6e5e0da062a6b77e6c952ZZfe64f823728394127",
    expiration_time: "2026-06-28 06:00:00",
    state: 1,
    state_check: 1,
    auth_response:
      '{"w1_expires_in":834486,"refresh_token_valid_time":1751061600000,"taobao_user_nick":"nike%E5%84%BF%E7%AB%A5%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97","re_expires_in":834486,"expire_time":1751061600000,"token_type":"Bearer","access_token":"62027304860cdd60b6e5e0da062a6b77e6c952ZZfe64f823728394127","taobao_open_uid":"AAEhsD1fAATDFH4XlaUPpGXz","w1_valid":1751061600000,"refresh_token":"6201c30071d34a4d54b9972205dbe3ece6bc34ZZ162af003728394127","w2_expires_in":1800,"w2_valid":1750228913859,"r1_expires_in":834486,"r2_expires_in":259200,"r2_valid":1750486313859,"r1_valid":1751061600000,"taobao_user_id":"3728394127","expires_in":834486}',
    text: "",
    create_date: "2023-06-28 12:06:45",
    update_date: "2025-06-30 09:47:54",
  },
  {
    id: 19,
    name: "nike%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97",
    user_name: "nike官方旗舰店",
    access_token: "6200f09f1b9ed8d97ZZ2eaff34b6d5c3762682515f7ea07890482188",
    expiration_time: "2026-06-28 06:00:00",
    state: 1,
    state_check: 1,
    auth_response:
      '{"w1_expires_in":834367,"refresh_token_valid_time":1751061600000,"taobao_user_nick":"nike%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97","re_expires_in":834367,"expire_time":1751061600000,"token_type":"Bearer","access_token":"6200f09f1b9ed8d97ZZ2eaff34b6d5c3762682515f7ea07890482188","taobao_open_uid":"AAEDsD1fAATDFH4XlaXkjQxw","w1_valid":1751061600000,"refresh_token":"6201709f5a8295d80ZZbf3d96102d0f2d87a5b505f678b4890482188","w2_expires_in":1800,"w2_valid":1750229032566,"r1_expires_in":834367,"r2_expires_in":259200,"r2_valid":1750486432566,"r1_valid":1751061600000,"taobao_user_id":"890482188","expires_in":834367}',
    text: "",
    create_date: "2023-06-28 12:11:17",
    update_date: "2025-06-30 09:47:28",
  },
  {
    id: 20,
    name: "tpmorefun",
    user_name: "tpmorefun",
    access_token: "6202409c4c086e23dfh37523a82fd345b97f7cd3b7e5c451928865133",
    expiration_time: "2025-04-30 06:00:00",
    state: 0,
    state_check: 0,
    auth_response:
      '{"w1_expires_in":2549382,"refresh_token_valid_time":1745964000000,"taobao_user_nick":"tpmorefun","re_expires_in":2549382,"expire_time":1745964000000,"token_type":"Bearer","access_token":"6202409c4c086e23dfh37523a82fd345b97f7cd3b7e5c451928865133","taobao_open_uid":"AAG3sD1fAATDFH4XlaWjZocR","w1_valid":1745964000000,"refresh_token":"6201309ebddb4dac7ZZ9bcecf601408ca56d5a3b95c7e491928865133","w2_expires_in":1800,"w2_valid":1743416417015,"r1_expires_in":2549382,"r2_expires_in":259200,"r2_valid":1743673817015,"r1_valid":1745964000000,"taobao_user_id":"1928865133","expires_in":2549382}',
    text: "",
    create_date: "2023-07-28 14:36:11",
    update_date: "2025-04-30 09:46:41",
  },
  {
    id: 21,
    name: "nike官方旗舰店bak",
    user_name: "nike官方旗舰店bak",
    access_token: "6202605493ee6ZZad09f6481b3dd2ad6f7f0aae9367c1343728394127",
    expiration_time: "2099-06-28 06:00:00",
    state: 1,
    state_check: 0,
    auth_response:
      '{"w1_expires_in":31600122,"refresh_token_valid_time":1719525600000,"taobao_user_nick":"nike%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97","re_expires_in":31600122,"expire_time":1719525600000,"token_type":"Bearer","access_token":"6201e06a60efb3ZZ51f6549770383012d55b702e7f40f82890482188","taobao_open_uid":"AAEDsD1fAATDFH4XlaXkjQxw","w1_valid":1719525600000,"refresh_token":"620070696910c6ZZ9452c04935c218c4e9da8722fd2ad77890482188","w2_expires_in":1800,"w2_valid":1687927277730,"r1_expires_in":31600122,"r2_expires_in":259200,"r2_valid":1688184677730,"r1_valid":1719525600000,"taobao_user_id":"890482188bak","expires_in":31600122}',
    text: null,
    create_date: "2023-06-28 12:11:17",
    update_date: "2024-06-28 10:25:00",
  },
  {
    id: 22,
    name: "nike%E5%AE%98%E6%96%B9outlets%E5%BA%97",
    user_name: "nike官方outlets店",
    access_token:
      "6202128e77ca09b6dfa188687a76b436fd56ZZ28c88814e2211883262676",
    expiration_time: "2026-02-27 06:00:00",
    state: 1,
    state_check: 1,
    auth_response:
      '{"w1_expires_in":844896,"refresh_token_valid_time":1740607200000,"taobao_user_nick":"nike%E5%AE%98%E6%96%B9outlets%E5%BA%97","re_expires_in":844896,"expire_time":1740607200000,"token_type":"Bearer","access_token":"6202128e77ca09b6dfa188687a76b436fd56ZZ28c88814e2211883262676","taobao_open_uid":"AAGHsD1fAATDFHwXlacvGoCo","w1_valid":1740607200000,"refresh_token":"6201b28047d299b2561f7bb8d108d5402c8ceg81ad20f352211883262676","w2_expires_in":1800,"w2_valid":1739764103829,"r1_expires_in":844896,"r2_expires_in":259200,"r2_valid":1740021503829,"r1_valid":1740607200000,"taobao_user_id":"2211883262676","expires_in":844896}',
    text: "",
    create_date: null,
    update_date: "2025-02-17 11:18:24",
  },
  {
    id: 23,
    name: "lamer%E6%B5%B7%E8%93%9D%E4%B9%8B%E8%B0%9C%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97",
    user_name: "lamer海蓝之谜官方旗舰店",
    access_token: "620212443a5cdcb1d2a78cd0108652c5ZZ59710c010a7282424298091",
    expiration_time: "2025-04-19 06:00:00",
    state: 0,
    state_check: 0,
    auth_response:
      '{"w1_expires_in":31520753,"refresh_token_valid_time":1745013600000,"taobao_user_nick":"lamer%E6%B5%B7%E8%93%9D%E4%B9%8B%E8%B0%9C%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97","re_expires_in":31520753,"expire_time":1745013600000,"token_type":"Bearer","access_token":"620212443a5cdcb1d2a78cd0108652c5ZZ59710c010a7282424298091","taobao_open_uid":"AAFHsD1fAATDFH4XlaVB4XgX","w1_valid":1745013600000,"refresh_token":"620072405ec3cb0154c38eb0e8bb4f75ZZ3e7b39535df9b2424298091","w2_expires_in":1800,"w2_valid":1713494646040,"r1_expires_in":31520753,"r2_expires_in":259200,"r2_valid":1713752046040,"r1_valid":1745013600000,"taobao_user_id":"2424298091","expires_in":31520753}',
    text: "",
    create_date: "2024-04-19 10:14:06",
    update_date: "2025-04-30 09:47:19",
  },
  {
    id: 24,
    name: "crocs%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97",
    user_name: "crocs官方旗舰店",
    access_token: "6201d154c35a698fd2473f1ZZ8041851ea7f496b1efc480748681129",
    expiration_time: "2026-06-25 06:00:00",
    state: 1,
    state_check: 1,
    auth_response:
      '{"w1_expires_in":31520944,"refresh_token_valid_time":1750802400000,"taobao_user_nick":"crocs%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97","re_expires_in":31520944,"expire_time":1750802400000,"token_type":"Bearer","access_token":"6201d154c35a698fd2473f1ZZ8041851ea7f496b1efc480748681129","taobao_open_uid":"AAE-sD1fAATDFH4XlaX9AVXV","w1_valid":1750802400000,"refresh_token":"6200b156e10c3f74d327f02ZZa53de41a95eaeec06dbfca748681129","w2_expires_in":1800,"w2_valid":1719283255168,"r1_expires_in":31520944,"r2_expires_in":259200,"r2_valid":1719540655168,"r1_valid":1750802400000,"taobao_user_id":"748681129","expires_in":31520944}',
    text: "",
    create_date: "2024-06-25 10:10:12",
    update_date: "2025-06-13 09:53:25",
  },
  {
    id: 25,
    name: "crocs%E7%AB%A5%E9%9E%8B%E6%97%97%E8%88%B0%E5%BA%97",
    user_name: "crocs童鞋旗舰店",
    access_token: "6202828c21322367652ad37d873403675081ZZ1b6fd3f131812902244",
    expiration_time: "2026-06-25 06:00:00",
    state: 1,
    state_check: 1,
    auth_response:
      '{"w1_expires_in":31517724,"refresh_token_valid_time":1750802400000,"taobao_user_nick":"crocs%E7%AB%A5%E9%9E%8B%E6%97%97%E8%88%B0%E5%BA%97","re_expires_in":31517724,"expire_time":1750802400000,"token_type":"Bearer","access_token":"6202828c21322367652ad37d873403675081ZZ1b6fd3f131812902244","taobao_open_uid":"AAEOsD1fAATDFH4XlaW9kBMY","w1_valid":1750802400000,"refresh_token":"6200328c88b515a831b5ca19742c52ec4c6fhj5ff09961d1812902244","w2_expires_in":1800,"w2_valid":1719286475372,"r1_expires_in":31517724,"r2_expires_in":259200,"r2_valid":1719543875372,"r1_valid":1750802400000,"taobao_user_id":"1812902244","expires_in":31517724}',
    text: "",
    create_date: "2024-06-25 11:04:35",
    update_date: "2025-06-16 08:35:05",
  },
  {
    id: 26,
    name: "arcteryx%E5%A7%8B%E7%A5%96%E9%B8%9F%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97",
    user_name: "arcteryx始祖鸟官方旗舰店",
    access_token: "6201e1475e0051cf5b0ec9ZZ74949924d1d1baecbdf2d1e1638981783",
    expiration_time: "2025-07-16 06:00:00",
    state: 0,
    state_check: 0,
    auth_response:
      '{"w1_expires_in":31491409,"refresh_token_valid_time":1752616800000,"taobao_user_nick":"arcteryx%E5%A7%8B%E7%A5%96%E9%B8%9F%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97","re_expires_in":31491409,"expire_time":1752616800000,"token_type":"Bearer","access_token":"6201e1475e0051cf5b0ec9ZZ74949924d1d1baecbdf2d1e1638981783","taobao_open_uid":"AAEhsD1fAATDFH4XlaWwLkLr","w1_valid":1752616800000,"refresh_token":"6202a14e6e21645203b7b2ZZ448e5d18cc6220e19e0e4061638981783","w2_expires_in":1800,"w2_valid":1721127190129,"r1_expires_in":31491409,"r2_expires_in":259200,"r2_valid":1721384590129,"r1_valid":1752616800000,"taobao_user_id":"1638981783","expires_in":31491409}',
    text: "",
    create_date: "2024-07-16 18:22:47",
    update_date: "2025-07-11 09:51:19",
  },
  {
    id: 27,
    name: "%E5%A4%A7%E7%A0%81%E7%BE%8E%E9%9E%8B%E5%A4%9A%E5%93%81%E5%BA%97",
    user_name: "大码美鞋多品店",
    access_token:
      "6200e14ba2ba530a12e60cegf7fe9d0c0c1dee477dccc0c2214773785969",
    expiration_time: "2025-08-29 06:00:00",
    state: 0,
    state_check: 0,
    auth_response:
      '{"w1_expires_in":31411970,"refresh_token_valid_time":1756418400000,"taobao_user_nick":"%E5%A4%A7%E7%A0%81%E7%BE%8E%E9%9E%8B%E5%A4%9A%E5%93%81%E5%BA%97","re_expires_in":31411970,"expire_time":1756418400000,"token_type":"Bearer","access_token":"6200e14ba2ba530a12e60cegf7fe9d0c0c1dee477dccc0c2214773785969","taobao_open_uid":"AAEUsD1fAATDFHwXlaZ7UKcN","w1_valid":1756418400000,"refresh_token":"6202614785939c1de1df97ZZcff1e3fc0522ec6b9b7a9ac2214773785969","w2_expires_in":1800,"w2_valid":1725008229089,"r1_expires_in":31411970,"r2_expires_in":259200,"r2_valid":1725265629089,"r1_valid":1756418400000,"taobao_user_id":"2214773785969","expires_in":31411970}',
    text: "",
    create_date: "2024-08-30 16:27:09",
    update_date: "2025-08-15 09:36:14",
  },
  {
    id: 28,
    name: "bata%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97",
    user_name: "bata官方旗舰店",
    access_token: "6200604d8d37ZZ5ce5933636476fba3bd6ca6b555aa6b651689954831",
    expiration_time: "2026-09-02 06:00:00",
    state: 1,
    state_check: 1,
    auth_response:
      '{"w1_expires_in":31498333,"refresh_token_valid_time":1756764000000,"taobao_user_nick":"bata%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97","re_expires_in":31498333,"expire_time":1756764000000,"token_type":"Bearer","access_token":"6200604d8d37ZZ5ce5933636476fba3bd6ca6b555aa6b651689954831","taobao_open_uid":"AAFqsD1fAATDFH4XlaW1JAhz","w1_valid":1756764000000,"refresh_token":"6201004f07f4ZZdcf5aa44625540b737b57cdf7765c0fab1689954831","w2_expires_in":1800,"w2_valid":1725267466265,"r1_expires_in":31498333,"r2_expires_in":259200,"r2_valid":1725524866265,"r1_valid":1756764000000,"taobao_user_id":"1689954831","expires_in":31498333}',
    text: "",
    create_date: "2024-09-02 16:27:46",
    update_date: "2025-09-08 09:51:07",
  },
  {
    id: 29,
    name: "joypeace%E7%9C%9F%E7%BE%8E%E8%AF%97%E6%97%97%E8%88%B0%E5%BA%97",
    user_name: "joypeace真美诗旗舰店",
    access_token: "6101e01ee1af9c0b820ffb76c0ff9545038c0392e44a74b2940972233",
    expiration_time: "2026-09-08 06:00:00",
    state: 1,
    state_check: 1,
    auth_response:
      '{"w1_expires_in":469171,"refresh_token_valid_time":1725746400000,"taobao_user_nick":"joypeace%E7%9C%9F%E7%BE%8E%E8%AF%97%E6%97%97%E8%88%B0%E5%BA%97","re_expires_in":469171,"expire_time":1725746400000,"token_type":"Bearer","sub_taobao_user_id":"2218160742735","access_token":"62006262b54a7ddd477f1b102c71d49f70ZZ14b299748e92218160742735","taobao_open_uid":"AAGssD1fAATDFH4XlaV-1Q61","w1_valid":1725746400000,"refresh_token":"6200f26ab8d57fbb2ed6f9d49c3571b259ZZed2c50b73402218160742735","w2_expires_in":1800,"sub_taobao_user_nick":"joypeace%E7%9C%9F%E7%BE%8E%E8%AF%97%E6%97%97%E8%88%B0%E5%BA%97%3A%E7%87%95%E7%9C%9F","w2_valid":1725279028112,"r1_expires_in":469171,"r2_expires_in":259200,"r2_valid":1725536428112,"r1_valid":1725746400000,"taobao_open_sub_uid":"AAFbsD1fAATDFHwXlaGlMEMz","taobao_user_id":"2940972233","expires_in":469171}',
    text: "",
    create_date: "2024-09-02 19:40:28",
    update_date: "2025-09-08 09:52:07",
  },
  {
    id: 30,
    name: "converse%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97",
    user_name: "converse官方旗舰店",
    access_token: "62022229d6408ade4437262f519521ZZ8af66f6e7c050fe1046707508",
    expiration_time: "2026-10-14 06:00:00",
    state: 1,
    state_check: 1,
    auth_response:
      '{"w1_expires_in":31509071,"refresh_token_valid_time":1791928800000,"taobao_user_nick":"converse%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97","re_expires_in":31509071,"expire_time":1791928800000,"token_type":"Bearer","access_token":"62022229d6408ade4437262f519521ZZ8af66f6e7c050fe1046707508","taobao_open_uid":"AAEpsD1fAATDFH4XlaXv_d9I","w1_valid":1791928800000,"refresh_token":"620282291ed9aba94ece041ebea2c3ZZdebf627764440261046707508","w2_expires_in":1800,"w2_valid":1760421528597,"r1_expires_in":31509071,"r2_expires_in":259200,"r2_valid":1760678928597,"r1_valid":1791928800000,"taobao_user_id":"1046707508","expires_in":31509071}',
    text: "",
    create_date: "2024-09-12 16:17:53",
    update_date: "2025-10-14 13:28:49",
  },
  {
    id: 31,
    name: "descente迪桑特官方旗舰店",
    user_name: "descente迪桑特官方旗舰店",
    access_token: "6101c1244c152ece6abc11c56234bc4ac22cc17ed38d9d53299471109",
    expiration_time: "2026-11-01 06:00:00",
    state: 1,
    state_check: 1,
    auth_response: '{\n    "taobao_user_id": "3299471109"\n}',
    text: null,
    create_date: null,
    update_date: "2025-11-03 09:39:17",
  },
  {
    id: 32,
    name: "thenorthface官方旗舰",
    user_name: "thenorthface官方旗舰",
    access_token: "61029277e9e9dc8809937a3ab42a72d5145120d0ca377ca928417138",
    expiration_time: "2026-12-19 06:00:00",
    state: 1,
    state_check: 1,
    auth_response: '{"taobao_user_id":"928417138"}',
    text: null,
    create_date: null,
    update_date: "2025-12-19 08:31:44",
  },
  {
    id: 33,
    name: "白兰氏官方旗舰店",
    user_name: "白兰氏官方旗舰店",
    access_token: "6102011f4dfcce25d891264f6f3141c1d6dd39e7dbf5078631257005",
    expiration_time: "2025-12-19 00:00:00",
    state: 0,
    state_check: 0,
    auth_response: '{"taobao_user_id":"631257005"}',
    text: null,
    create_date: null,
    update_date: "2025-12-10 10:11:54",
  },
  {
    id: 34,
    name: "macallan%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97",
    user_name: "macallan官方旗舰店",
    access_token:
      "6201525d0a1a49c8657bef858758361b6ZZbc798d6a86062213122546531",
    expiration_time: "2026-03-26 06:00:00",
    state: 1,
    state_check: 1,
    auth_response:
      '{"w1_expires_in":31520863,"refresh_token_valid_time":1774476000000,"taobao_user_nick":"macallan%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97","re_expires_in":31520863,"expire_time":1774476000000,"token_type":"Bearer","access_token":"6201525d0a1a49c8657bef858758361b6ZZbc798d6a86062213122546531","taobao_open_uid":"AAECsD1fAATDFHwXlaaZ_Lkf","w1_valid":1774476000000,"refresh_token":"6201925fdad5789a82a4f1bec9f8f37b9ZZe307862230612213122546531","w2_expires_in":1800,"w2_valid":1742956936769,"r1_expires_in":31520863,"r2_expires_in":259200,"r2_valid":1743214336769,"r1_valid":1774476000000,"taobao_user_id":"2213122546531","expires_in":31520863}',
    text: "",
    create_date: "2025-03-26 10:12:17",
    update_date: "2025-03-26 10:12:17",
  },
  {
    id: 35,
    name: "lululemon%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97",
    user_name: "lululemon官方旗舰店",
    access_token: "6201818b70d530e85cfda665e2ZZ016f4d4cfa614ec95fa2635590370",
    expiration_time: "2026-09-22 06:00:00",
    state: 1,
    state_check: 1,
    auth_response:
      '{"w1_expires_in":31507835,"refresh_token_valid_time":1790028000000,"taobao_user_nick":"lululemon%E5%AE%98%E6%96%B9%E6%97%97%E8%88%B0%E5%BA%97","re_expires_in":31507835,"expire_time":1790028000000,"token_type":"Bearer","access_token":"6201818b70d530e85cfda665e2ZZ016f4d4cfa614ec95fa2635590370","taobao_open_uid":"AAHRsD1fAATDFH4XlaVMiUie","w1_valid":1790028000000,"refresh_token":"620201844595e3de713a3655e1ZZ1a3ad3daa7843ffc36b2635590370","w2_expires_in":1800,"w2_valid":1758521964874,"r1_expires_in":31507835,"r2_expires_in":259200,"r2_valid":1758779364874,"r1_valid":1790028000000,"taobao_user_id":"2635590370","expires_in":31507835}',
    text: "",
    create_date: "2025-09-22 13:49:25",
    update_date: "2025-09-22 13:49:25",
  },
  {
    id: 36,
    name: "JELLYCAT官方旗舰店",
    user_name: "jellycat官方旗舰店",
    access_token: "610050258a1be816e833ca990ca5099ef228573ee2ec5653984573045",
    expiration_time: "2027-01-13 16:31:15",
    state: 1,
    state_check: 1,
    auth_response: '{\n    "taobao_user_id": "3984573045"\n}',
    text: null,
    create_date: null,
    update_date: null,
  },
];

export const jdShopNameList = [
  {
    id: 1,
    shopName: "NIKE官方旗舰店",
    shopId: "15523024",
    cleanOrderTime: "2026-05-06 15:34:29",
    cleanEnabled: 1,
    cleanRunning: 0,
    lastCleanTime: "2026-05-06 15:34:30",
    cleanTimeoutSeconds: 7200,
    ext: null,
    authEndTime: "2026-09-17 16:55:41",
    dingWarringEnabled: 1,
    createTime: "2025-06-09 16:51:53",
    updateTime: "2026-05-06 15:34:29",
  },
  {
    id: 2,
    shopName: "CHANEL香奈儿官方旗舰店 香水与美容品",
    shopId: "247403600",
    cleanOrderTime: "2026-05-06 15:34:29",
    cleanEnabled: 1,
    cleanRunning: 1,
    lastCleanTime: "2026-05-06 15:34:30",
    cleanTimeoutSeconds: 7200,
    ext: null,
    authEndTime: "2027-05-07 18:25:18",
    dingWarringEnabled: 1,
    createTime: "2025-06-09 16:51:53",
    updateTime: "2026-05-06 15:34:29",
  },
];
